module.exports = __webpack_public_path__ + "img/job.208cfed3.png";